export default __webpack_public_path__ + "2ed4133e6f6933efc66f7a33cee2cc90.svg";